<ion-content [fullscreen]="false">

  @if (reservationPage == false && !urlstore) {
    <div  style="height: auto;" >
      <ion-segment (ionChange)="segmentChanged()" [value]="pickupValue">
        <ion-segment-button class="button" value="address">
          <ion-label> {{ 'Store.ByAddress' | translate}}</ion-label>
        </ion-segment-button>
        <ion-segment-button style="margin-right: 20px" class="button" value="position" >
          <ion-label>{{ 'Store.ByPosition' | translate}}</ion-label>
        </ion-segment-button>
      </ion-segment>
      <br>
        @if (segmentValue && segmentValue == 'address') {
          <ion-item (click)="beginChangeAddress()" class="disable-background-color hoverAddress">
            <p style="white-space: pre;">{{ 'Store.YourAddress' | translate }}</p>
            <ion-icon name="chevron-forward-outline" item-right class="animatedChevron"></ion-icon>
            @if (address) {
              <p>{{ formatedAddress }}</p>
            }
          </ion-item>
        }
        <br>
          @if (geopoint) {
            <ion-grid style="height: 100%;">
              <ion-row>
                @if (storeValidRange.length == 0) {
                  <ion-col ><h1> {{ 'Store.NoStoreInRange' | translate}}</h1></ion-col>
                }
                <!--<ion-col *ngFor="let store of stores" style="padding:0px; min-width: 70%;"> -->
                @for (store of storeOnDisplay; track store) {
                  <ion-col style="padding:0px; min-width: 70%;">
                    @if (isOpen(store)) {
                      <ion-card  class="store" (click)="reservationStore(store)">
                        <ion-card-header class="card_layout">
                          <ion-card-title class="titleAdjust"><b class="storetitleclose cards-font-size">{{ store.displayName }}</b></ion-card-title>
                          <ion-card-subtitle class="text_adjust store_text_address">{{ store.address.city }}</ion-card-subtitle>
                          <ion-card-subtitle class="text_adjust">
                            {{ store._distance | number:'1.2-2' }} km @if (store.timeMin) {
                            <span>• {{ store.timeMin }}-{{ store.timeMax }} Min • $</span>
                          }
                        </ion-card-subtitle>
                      </ion-card-header>
                    </ion-card>
                  }
                  @if (!isOpen(store)) {
                    <ion-card  class="store" (click)="displayReservationAlert(reservationCallDialog, store)">
                      <ion-card-header class="card_layout changeFlex closed">
                        <div class="cardContent">
                          <ion-card-title class="titleAdjust"><b class="storetitleopen cards-font-size">{{ store.displayName }}</b></ion-card-title>
                          <ion-card-subtitle class="text_adjust store_text_address">{{ store.address.city }}</ion-card-subtitle>
                          <ion-card-subtitle class="text_adjust">
                            {{ store._distance | number:'1.2-2' }} km @if (store.timeMin) {
                            <span>• {{ store.timeMin }}-{{ store.timeMax }} Min • $</span>
                          }
                        </ion-card-subtitle>
                      </div>
                      <div class="cardButton">
                        <ion-card-subtitle class="text_adjust" style="display: flex; justify-content: center;">
                          <ion-button class="btnOrderLater" type="button" color="primary">
                            {{ 'Store.StoreOfflineCallStore' | translate}}
                          </ion-button>
                        </ion-card-subtitle>
                      </div>
                    </ion-card-header>
                  </ion-card>
                }
              </ion-col>
            }
          </ion-row>
          <mat-paginator [length]="TotalPage"
            [pageSize]="storesperpage"
            [pageIndex]="CurrentPage - 1"
            (page)="onPaginateChange($event)"
            showFirstLastButtons
            class="disable-background-color">
          </mat-paginator>
          <div class="footerInformation">
            <mat-form-field appearance="fill" style="font-size: 14px; width: 100px;">
              <mat-select name="selectedLayout" [ngModel]="selectedLanguage" (ngModelChange)="changeLang($event)">
                @for (language of languages; track language) {
                  <mat-option [value]="language">
                    {{'Language.' + language | translate}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="ToSsection">
              <ion-label class="lbl-wrap" style="margin: 0;font-size: .7rem;">
                <a style="cursor: pointer;" (click)="showTerms($event)">{{ 'CreditCard.Agreements.Terms' | translate }}</a>
                |
                <a style="cursor: pointer;" (click)="showPolicies($event)">{{ 'CreditCard.Agreements.Policies' | translate }}</a>
              </ion-label>
            </div>
          </div>
        </ion-grid>
      }
    </div>
  }


  @if (reservationPage) {
    <div style="height: auto;">
      <ion-card class="reservation_content_layout">
        <ion-card-header>
          <ion-card-title style="font-size: 26px; display: flex; text-align: center; justify-content: center;"><b>{{ 'ReservationPage.ReserveSpot' | translate}}</b></ion-card-title>
          <br>
            <ion-card-title style="display: flex; text-align: center; justify-content: center;"><b>{{ selectedStore.displayName }}</b></ion-card-title>
            <ion-card-subtitle style="font-size: 16px; display: flex; text-align: center; justify-content: center;">{{ selectedStore.address.city }}</ion-card-subtitle>
          </ion-card-header>
          <!--
          <ion-row>
            <ion-col style="padding: 0;">
              <div class="custom-form-group">
                <input formControlName="firstname" (ionChange)="submit()" id="firstname" class="form-control" type="text"  placeholder="" required>
                <label for="firstname">{{ 'Checkout.Form.FirstName' | translate }}<span style="color:red;">*</span></label>
                <mat-datepicker-toggle matSuffix [for]="resStart"></mat-datepicker-toggle>
                <mat-datepicker #resStart></mat-datepicker>
              </div>
            </ion-col>
            <ion-col style="padding: 0;">
              <div class="custom-form-group">
                <input
                  matInput
                  [min]="minDate" [max]="maxDate"
                  [matDatepicker]="resStart"
                  placeholder="Date"
                  name="reservationDate"
                  [ngModel]="reservationDate"
                  (ngModelChange)="getOpenHours($event)"
                  />
                  <label for="lastname">{{ 'Checkout.Form.LastName' | translate }}<span style="color:red;">*</span></label>
                  <span style="padding-bottom: 2px;"class="form-errors">{{ 'Checkout.FormErrors.LastNameRequired' | translate}}</span>
                </div>
              </ion-col>
            </ion-row>
            -->
            @if (availability == false && reservationSuccessfull == false && storeLayout && storeLayout.AllowDifferentLayouts == true) {
              <ion-card-content style="display: flex;">
                <mat-form-field class="custom-height fieldinput"  appearance="fill">
                  <mat-label>{{ 'Store.Floor' | translate }}</mat-label>
                  <mat-select name="selectedLayout" style="padding-top: 5px;" [ngModel]="selectedLayout" (ngModelChange)="selectedLayoutUpdate($event)">
                    <!-- <mat-option>--</mat-option> -->
                    @for (layoutDetail of storeLayout.LayoutDetails; track layoutDetail) {
                      <mat-option [value]="layoutDetail">
                        {{layoutDetail.Name}}
                      </mat-option>
                    }
                    <!-- <mat-option [value]="N/A">No Preferrence</mat-option> -->
                  </mat-select>
                </mat-form-field>
              </ion-card-content>
            }
            @if (availability == false && reservationSuccessfull == false && storeLayout && (storeLayout.AllowDifferentLayouts == false || selectedLayout)) {
              <ion-card-content style="display: flex; flex-wrap: wrap; align-items: center; justify-content: center;">
                <div class="optionsrow">
                  <mat-form-field class="custom-height fieldinput" appearance="fill">
                    <mat-label>{{ 'ReservationPage.Guests' | translate}}</mat-label>
                    <input type="number" matInput name="reservationGuests" min="1" max="100" [ngModel]="reservationGuests" (ngModelChange)="updateReservationGuests($event)" />
                  </mat-form-field>
                  <mat-form-field class="custom-height fieldinput" appearance="fill">
                    <mat-label>Date</mat-label>
                    <input
                      matInput
                      [min]="minDate" [max]="maxDate"
                      [matDatepicker]="resStart"
                      placeholder="Date"
                      name="reservationDate"
                      [ngModel]="reservationDate"
                      (ngModelChange)="getOpenHours($event)"
                      />
                      <mat-datepicker-toggle matSuffix [for]="resStart"></mat-datepicker-toggle>
                      <mat-datepicker #resStart></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="optionsrow">
                    @if (storeLayout.SectionsIncluded == true) {
                      <mat-form-field class="custom-height fieldinput" appearance="fill">
                        <mat-label>Section</mat-label>
                        <mat-select name="selectedSection" style="padding-top: 10px;" [ngModel]="selectedSection" (ngModelChange)="selectedSectionUpdate($event)">
                          <!-- <mat-option>--</mat-option> -->
                          @for (section of storeSections; track section) {
                            <mat-option [value]="section">
                              {{section.SectionName}}
                            </mat-option>
                          }
                          <!-- <mat-option [value]="N/A">No Preferrence</mat-option> -->
                        </mat-select>
                      </mat-form-field>
                    }
                    @if (storeLayout.EmployeesIncluded == true) {
                      <mat-form-field class="custom-height fieldinput" appearance="fill">
                        <mat-label>{{ 'Store.Employee' | translate}}</mat-label>
                        <mat-select name="selectedEmployee" style="padding-top: 10px;" [ngModel]="selectedEmployee" (ngModelChange)="selectedEmployeeUpdate($event)">
                          @for (employee of tempstoreEmployees; track employee) {
                            <mat-option [value]="employee">
                              {{employee.FirstName}} {{employee.LastName}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </div>
                  <!-- <mat-form-field appearance="fill" style="font-size: 14px; width: 170px; padding: 3px;" >
                  <mat-label>{{ 'ReservationPage.Time' | translate}}</mat-label>
                  <mat-select [(ngModel)]="reservationHour"  name="time" >
                    <mat-option *ngFor="let time of getTimeIntervals()" [value]="time">
                      {{time}}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
                <button  type="button" class="display-top-btn reservebtncolor" style="margin-left: 4px;" color="accent" mat-raised-button [disabled]="reservationDate == undefined"  (click)="checkAvailableTimesForDate()">{{ 'ReservationPage.CheckAvailability' | translate}}</button>
              </ion-card-content>
            }
            @if (ChangedDate) {
              <ion-card-content>
                <p class="alertMessageAlign" style="font-size: 12px; color: red;">{{ 'ReservationPage.DateNoTime' | translate}}<br>{{ 'ReservationPage.NewDateAvailable' | translate}}{{ this.DateTimeBuilder() }}</p>
              </ion-card-content>
            }
            @if (availability == false && reservationSuccessfull == false && showavavailableTimes) {
              <ion-card-content >
                <!-- <table>
                <tr>
                  <td *ngFor="let time of availableTimes; let i = index">
                    <button style="margin-left: 5px; background-color: #96af18; color: white;" (click)="checkAvailability(time)" type="button" mat-raised-button color="accent" >{{time.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}}</button>
                  </td>
                </tr>
              </table> -->
              @if (availableTimes.length > 0) {
                <ion-grid>
                  <ion-row class="availabilitywidth" no-padding>
                    @for (time of availableTimes; track time; let i = $index) {
                      <ion-col  class="ion-align-self-start availabilitytimelayout">
                        <button class="reservebtncolor availabilitySelectors" style="margin-left: 5px;" (click)="checkAvailability(time)" type="button" mat-raised-button color="accent" >{{time.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}}</button>
                      </ion-col>
                    }
                  </ion-row>
                </ion-grid>
              }
              @if (availableTimes.length < 1) {
                <p class="alertMessageAlign" style="font-size: 16px; color: red;">{{ 'Store.CannotReserve' | translate }}</p>
              }
            </ion-card-content>
          }
          @if (errorMessage) {
            <ion-card-content>
              <p class="alertMessageAlign" style="font-size: 16px; color: red;">{{ 'ReservationPage.ContactStore' | translate}} {{storeLayout.OnlineReservationLimit}}</p>
            </ion-card-content>
          }
          @if (availability == true && reservationSuccessfull == false) {
            <ion-card-content class="centeredtext">
              <p style="font-size: 16px;"><strong>{{'ReservationPage.TotalGuests' | translate}}: {{reservationGuests}}</strong></p>
              <p class="centeredtext" style="font-size: 16px;"><strong>{{'ReservationPage.ReservationTime' | translate}}: <br>{{DateTimeBuilder()}} {{'ReservationPage.At' | translate}} {{this.reservationDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}} </strong></p>
              <button class="reservebtncolor btnstartagain centeredtext" type="button" mat-raised-button  (click)="redoAvailability()">{{'ReservationPage.StartAgain' | translate}}</button>
            </ion-card-content>
          }
          @if (availability == true && reservationSuccessfull == false) {
            <ion-card-content class="centeredtext" style="flex-direction: row; flex-wrap: wrap;" >
              <div class="optionsrow">
                <mat-form-field appearance="fill" style="font-size: 14px; width: 170px; padding: 3px;">
                  <mat-label>{{'ReservationPage.Name' | translate}}</mat-label>
                  <input  type="text" matInput name="guestName" [(ngModel)]="guestName">
                </mat-form-field>
                <mat-form-field appearance="fill" style="font-size: 14px; width: 170px; padding: 3px;">
                  <mat-label>{{'fav.Phone' | translate}}</mat-label>
                  <input  type="text" matInput name="guestPhone" [(ngModel)]="guestPhone">
                </mat-form-field>
              </div>
              <div class="optionsrow">
                <mat-form-field appearance="fill" style="font-size: 14px; width: 170px; padding: 3px;">
                  <mat-label>{{'fav.Email' | translate}}</mat-label>
                  <input  type="text" matInput name="guestEmail" [(ngModel)]="guestEmail">
                </mat-form-field>
                <!-- <button type="button" mat-raised-button [disabled]="guestEmail == '' || guestPhone == '' || guestEmail == '' "  color="primary" (click)="reserve()">Reserve</button> -->
                @if (storeLayout.Children == true) {
                  <mat-form-field style="font-size: 14px; width: 170px; padding: 3px;" appearance="fill">
                    <mat-label>{{'ReservationPage.Children' | translate}}</mat-label>
                    <input type="number" matInput name="countChildren"  min="0" max="20"  [(ngModel)]="countChildren"/>
                  </mat-form-field>
                }
              </div>
              <div class="optionsrow">
                @if (storeLayout.HighChair == true) {
                  <mat-form-field style="font-size: 14px; width: 170px; padding: 3px;" appearance="fill">
                    <mat-label>{{'ReservationPage.HighChair' | translate}}</mat-label>
                    <input type="number" matInput name="countHighChair"  min="0" max="20"  [(ngModel)]="countHighChair"/>
                  </mat-form-field>
                }
                @if (storeLayout.ChairBooster == true) {
                  <mat-form-field style="font-size: 14px; width: 170px; padding: 3px;" appearance="fill">
                    <mat-label>{{'ReservationPage.Booster' | translate}}</mat-label>
                    <input type="number" matInput name="countBooster"  min="0" max="20"  [(ngModel)]="countBooster"/>
                  </mat-form-field>
                }
              </div>
            </ion-card-content>
          }
          @if (availability == true && reservationSuccessfull == false) {
            <ion-card-content>
              <mat-form-field style="font-size: 14px; width: 250px; padding: 3px;" appearance="fill">
                <mat-label>{{'ReservationPage.SpecialRequests' | translate}}</mat-label>
                <textarea matInput  name="specialRequests" [(ngModel)]="specialRequests" ></textarea>
              </mat-form-field>
              <!-- <button type="button" mat-raised-button [disabled]="guestEmail == '' || guestPhone == '' || guestEmail == '' "  color="primary" (click)="reserve()">Reserve</button> -->
            </ion-card-content>
          }
          @if (availability == true && reservationSuccessfull == false && reservationSectionPackages.length > 0) {
            <ion-card-content>
              <ion-grid class="grid-wrapper">
                @for (package of reservationSectionPackages; track package; let i = $index) {
                  <ion-row>
                    <ion-col size="12" size-lg class="horizontal-col package-card">
                      <ion-card style="margin: 0; height: 100%;">
                        <ion-grid style="height:100%; padding: 0;">
                          <ion-row style="height:100%;">
                            <ion-col size="3" style="padding: 0 8px 0 0;">
                              <div class="package-image-container" [style.background-image]="getPackageImage(package)">
                              </div>
                            </ion-col>
                            <ion-col size="9">
                              <div class="item-name-price">
                                {{ package.ItemName ? package.ItemName.translations[translationService.getLanguage()] : "" }} ({{package.Price | currency}})
                              </div>
                              <div style="position: relative;">
                                @if (package.Description && package.Description.translations[translationService.getLanguage()] != '') {
                                  <p id="description{{ i }}" class="item-description"
                                    [innerHTML]="sanitizer.bypassSecurityTrustHtml(package.Description.translations[translationService.getLanguage()])">
                                  </p>
                                }
                                @if (!package.Description || (package.Description && package.Description.translations[translationService.getLanguage()] == '')) {
                                  <p id="description{{ i }}" class="item-description">
                                    &nbsp;<br>
                                  </p>
                                }
                                <div id="note{{ i }}" class="item-note">
                                  <input class="note-input" style="width: 100%; border-color: #d3d3d385;" type="text"
                                    [(ngModel)]="package.SpecialRequest" placeholder="Special Request">
                                  </div>
                                  <div class="ellipsis" (click)="toggleDescriptionView(i)">...</div>
                                </div>
                              </ion-col>
                            </ion-row>
                          </ion-grid>
                        </ion-card>
                      </ion-col>
                      <ion-col class="add-remove-col">
                        <ion-fab horizontal="end" class="inline-menu-add" edge  vertical="center">
                          <button mat-button color="primary" (click)="removePackage(i)" [disabled]="package.Quantity < 1"><mat-icon> remove </mat-icon></button>
                          {{package.Quantity}}
                          <button mat-button color="primary" (click)="addPackage(i)" [disabled]="countSelectedPackages >= reservationGuests"><mat-icon> add </mat-icon></button>
                        </ion-fab>
                      </ion-col>
                    </ion-row>
                  }
                </ion-grid>
              </ion-card-content>
            }
            @if (reservationSuccessfull == true) {
              <ion-card-content>
                @if (storeLayout.EmailValidationRequired == false) {
                  <p style="font-size: 16px;"><strong>{{'ReservationPage.ReservationSuccessfull' | translate}}</strong></p>
                }
                @if (storeLayout.EmailValidationRequired == true) {
                  <p style="font-size: 16px;"><strong>{{'ReservationPage.ReservationAwaitingConfirmationByEmail' | translate}}</strong></p>
                }
                <p style="font-size: 14px;"><strong>{{'ReservationPage.Name' | translate}}  : {{guestName}}</strong></p>
                <p style="font-size: 14px;"><strong>{{'fav.Phone' | translate}} : {{guestPhone}}</strong></p>
                <p style="font-size: 14px;"><strong>{{'fav.Email' | translate}} : {{guestEmail}}</strong></p>
                <p style="font-size: 14px;"><strong>{{'ReservationPage.TotalGuests' | translate}} : {{reservationGuests}}</strong></p>
                <p style="font-size: 14px;"><strong>{{'ReservationPage.ReservationTime' | translate}} : {{this.reservationDate.toDateString()}} {{'ReservationPage.At' | translate}} {{this.reservationDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}}</strong></p>
              </ion-card-content>
            }
            <ion-card-content>
              @if (availability == true && reservationSuccessfull == false && reservationClicked == false && reservationSectionPackages.length > 0) {
                <button class="reservebtncolor" style="margin-left: 5px;" color="accent"  type="button" mat-raised-button [disabled]="guestEmail == '' || guestPhone == '' || guestEmail == '' || countSelectedPackages != reservationGuests"   (click)="cart()">Pay & Reserve</button>
              }
              @if (availability == true && reservationSuccessfull == false && reservationClicked == false && reservationSectionPackages.length == 0) {
                <button class="reservebtncolor" style="margin-left: 5px;" color="accent"  type="button" mat-raised-button [disabled]="guestEmail == '' || guestPhone == '' || guestEmail == '' "   (click)="reserve()">{{'ReservationPage.Reserve' | translate}}</button>
              }
              @if (availability == false && reservationSuccessfull == false && storeLayout && (storeLayout.AllowDifferentLayouts == false || selectedLayout)) {
                <button class="display-bottom-btn reservebtncolor" type="button" style="margin-left: 5px;" color="accent" mat-raised-button [disabled]="reservationDate == undefined"  (click)="checkAvailableTimesForDate()">{{ 'ReservationPage.CheckAvailability' | translate}}</button>
              }
              @if (reservationSuccessfull == false) {
                <button class="reservebtncolor" style="margin-left: 5px;" type="button" mat-raised-button color="accent"  (click)="reservationClose()">{{'ReservationPage.Cancel' | translate}}</button>
              }
              @if (reservationSuccessfull == true) {
                <button class="reservebtncolor" style="margin-left: 5px;" type="button" mat-raised-button color="accent"  (click)="reservationClose()">{{'ReservationPage.MakeAnotherReservation' | translate}}</button>
              }
            </ion-card-content>
            <!-- <button type="button" mat-raised-button float="right" color="primary" (click)="reservationClose()">Cancel</button> -->
            <br>
            </ion-card>
            <div class="footerInformation">
              <mat-form-field appearance="fill" style="font-size: 14px; width: 100px;">
                <mat-select name="selectedLayout" [ngModel]="selectedLanguage" (ngModelChange)="changeLang($event)">
                  @for (language of languages; track language) {
                    <mat-option [value]="language">
                      {{'Language.' + language | translate}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <div class="ToSsection">
                <ion-label class="lbl-wrap" style="margin: 0;font-size: .7rem;">
                  <a style="cursor: pointer;" (click)="showTerms($event)">{{ 'CreditCard.Agreements.Terms' | translate }}</a>
                  |
                  <a style="cursor: pointer;" (click)="showPolicies($event)">{{ 'CreditCard.Agreements.Policies' | translate }}</a>
                </ion-label>
              </div>
            </div>
          </div>
        }

      </ion-content>

      <ng-template #reservationCallDialog>
        <mat-dialog-content>
          <h4>{{'Store.NoInternetDisplay' | translate}}</h4>
          <h4>
            {{'Account.PhoneNumber' | translate}}: {{clickedStorePhone.number}}@if (clickedStorePhone.extension != null && clickedStorePhone.extension != '') {
            , Ext. {{clickedStorePhone.extension}}
          }
          <ion-button class="call-btn" type="button" (click)="callStore()">
            {{ 'Store.Call' | translate}}
          </ion-button>
        </h4>
      </mat-dialog-content>
    </ng-template>

